import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { collection, doc, documentId, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import { carrierApi } from '../../firebase/functionsService';
import { CARRIER_ROLE_LABEL } from '../../utils/carrierRoles';
import { ui } from './carrierStyles';

const ACTIVE_ROLE_KEY = 'tippi_activeRole';

// Svarside for invitasjon til et transportfirma (varselet peker hit).
export default function CarrierInviteAccept() {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [state, setState] = useState({ loading: true, orgName: '', role: null, pending: false });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [orgSnap, memberSnap] = await Promise.all([
          getDocs(query(collection(db, 'organizations'), where(documentId(), '==', orgId))),
          getDoc(doc(db, 'organizations', orgId, 'members', currentUser.uid)),
        ]);
        const org = orgSnap.docs[0]?.data();
        const member = memberSnap.exists() ? memberSnap.data() : null;
        if (cancelled) return;
        setState({
          loading: false,
          orgName: org?.orgName ?? 'transportfirmaet',
          role: member?.role ?? null,
          pending: Boolean(member && member.status === 'pending' && org?.type === 'carrier'),
        });
      } catch {
        if (!cancelled) setState({ loading: false, orgName: '', role: null, pending: false });
      }
    })();
    return () => { cancelled = true; };
  }, [orgId, currentUser.uid]);

  async function respond(accept) {
    setBusy(true);
    setError('');
    try {
      await carrierApi.respondToCarrierInvite({ orgId, accept });
      if (!accept) { navigate('/'); return; }
      // Rollene endres på serveren. Aktiv rolle lagres og siden lastes på nytt, slik at hele appen leser oppdatert bruker.
      const target = state.role === 'driver' ? 'driver' : 'carrier';
      try { localStorage.setItem(ACTIVE_ROLE_KEY, target); } catch { /* lagring kan være blokkert */ }
      window.location.assign(target === 'driver' ? '/driver' : '/transportor');
    } catch (err) {
      setError(err.message || 'Kunne ikke svare på invitasjonen');
      setBusy(false);
    }
  }

  if (state.loading) return <main style={ui.main}><p style={ui.hint}>Laster…</p></main>;

  return (
    <main style={{ ...ui.main, maxWidth: 480 }}>
      <h1 style={ui.h1}>Invitasjon</h1>
      <div style={ui.card}>
        {state.pending ? (
          <>
            <p>Du er invitert til <strong>{state.orgName}</strong> som {CARRIER_ROLE_LABEL[state.role]?.toLowerCase()}.</p>
            {error && <p role="alert" style={ui.error}>{error}</p>}
            <div style={{ ...ui.row, marginTop: 14 }}>
              <button type="button" className="tippi-btn" style={ui.btn} onClick={() => respond(true)} disabled={busy}>Godta</button>
              <button type="button" style={ui.btnSecondary} onClick={() => respond(false)} disabled={busy}>Avslå</button>
            </div>
          </>
        ) : (
          <p style={ui.hint}>Du har ingen ventende invitasjon til dette firmaet.</p>
        )}
      </div>
    </main>
  );
}
